/* eslint-disable max-statements-per-line */
import { AppContext } from './../../contexts/app-context';
import { useContext, useEffect } from 'react';

const Gtm = ({ type = '', data = '' }) => {
    const { mainProducts, page, productData, partnerData, isPlanProduct } = useContext(AppContext);

    const gtmFunction = (type = 'begin', other = '') => {
        if (typeof (document) !== 'undefined') {

            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.innerHTML = 'window.dataLayer = window.dataLayer || [];';
            if (type === 'load') {
                if (page === 'product' && productData.length !== 0) {
                    script.innerHTML += `dataLayer.push({
                        'event': 'load',
                        'mail_code': "${productData.mailcode}",
                        'originator': "${productData.originator}",
                        'content_group': "${isPlanProduct ? 'Plan' : 'Product'}",
                        'page_content': '',
                        'content_group2': "${productData.shortName.trim()}",
                        'partner_id': "${productData.partnerId}",
                        'partner_name': "${productData.partnerName.replace('-LL', '')}"
                    });`;
                    script.innerHTML += `dataLayer.push({
                        'event': 'view_item',
                        'ecommerce': {
                        'items': [{
                            'item_id': "${productData.areacode}.${productData.mailcode}",
                            'item_id_2': "${productData.crmId}",
                            'item_name': "${productData.shortName ? productData.shortName.trim() : productData.name.trim()}",
                            'item_category': "${productData?.coverType === 'Landlord' ? 'Landlords' : 'Homeowner'}",
                            'item_category2': "${(productData.fullName).includes('Flats') ? 'Flat' : (productData.fullName).includes('Houses') ? 'House' : 'Not Applicable'}",
                            'item_category3': "${(productData?.content?.productElement?.includes('Hap') || (productData?.content?.productElement?.includes('Heat Pump Plan') || productData?.content?.productElement?.includes('Plan'))) ? 'Not Applicable' : productData?.price?.excessPriceFormatted}",
                            'item_category4': "${productData.serviceIncluded === true ? 'Service Included' : 'Service not Included'}",
                            'price': "${productData.price.yearlyPrice}",
                            'currency': 'GBP',
                            'quantity': 1
                        }]
                        }
                    });`;
                } else if (page === 'comparison' && partnerData.length !== 0) {
                    let items = [];
                    mainProducts.forEach((value) => {
                        items = [...items, {
                            'item_id': `${value.areacode}.${value.mailcode}`,
                            'item_id_2': `${value.crmId}`,
                            'item_name': `${value.shortName ? value.shortName : value.name}`,
                            'item_category': `${value?.coverType === 'Landlord' ? 'Landlords' : 'Homeowner'}`,
                            'item_category2': `${(value.fullName).includes('Flats') ? 'Flat' : (value.fullName).includes('Houses') ? 'House' : 'Not Applicable'}`,
                            'item_category3': `${(value?.content?.productElement?.includes('Hap') || (value?.content?.productElement?.includes('Heat Pump Plan') || value?.content?.productElement?.includes('Plan'))) ? 'Not Applicable' : value?.price?.excessPriceFormatted}`,
                            'item_category4': `${(value.fullName).includes('Service') ? 'Service Included' : 'Service not Included'}`,
                            'price': `${value.price.yearlyPrice}`,
                            'currency': 'GBP',
                            'quantity': 1
                        }];
                    });
                    script.innerHTML = `window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                      'originator': 'partner',
                      'pageCategory': 'insurance',
                      'pageContent': 'comparison table',
                      'pageSubcategory': 'Plumbing comparison',
                      'partnerId': '${partnerData?.code}',
                      'partnerName': '${partnerData?.name.replace('-LL', '')}',
                      'referrer': '${typeof (window) !== 'undefined' ? window?.document?.referrer : ''}'
                    });
                    dataLayer.push({
                      'event': 'load',
                      'originator': 'partner',
                      'content_group': 'insurance',
                      'page_content': 'comparison table',
                      'content_group2': 'Plumbing comparison',
                      'partner_id': '${partnerData?.code}',
                      'partner_name': '${partnerData?.name}'
                    });
                    dataLayer.push({
                      "event": "view_item_list",
                      "ecommerce": {
                        "items": ${JSON.stringify(items)}
                      }
                  });`;
                }
            }
            if (type === 'clickAccordian') {
                script.innerHTML += `dataLayer.push({
                    'event': 'click_accordion',
                    'action': 'open',
                    'link_text': "${other.trim()}",
                    'type': 'Frequently asked questions'
                });`;
            }
            document.head.append(script);
        }
    };

    useEffect(() => {
        if (type === '' && data === '') {
            gtmFunction('load', '');
        }
    }, [productData]);

    useEffect(() => {
        if (type !== '' && data !== '') {
            gtmFunction(type, data);
        }
    }, [type, data]);

    return true;
};
export default Gtm;
